import { Component } from '@verndale/core';
import createScrollShapes from '../helpers/createScrollShapes';

class FeaturedResourceCardsWithImage extends Component {
  setupDefaults() {
    this.buildShapes();
  }

  buildShapes() {
    const { offsetHeight } = this.el;

    this.dom.shapes = createScrollShapes({
      containerEl: this.el,
      count: 3,
      prefix: 'featured-resource-cards-with-image__top-',
      offset: offsetHeight * 0.2
    });

    this.dom.shapes = createScrollShapes({
      containerEl: this.el,
      count: 2,
      prefix: 'featured-resource-cards-with-image__bottom-',
      offset: offsetHeight * 0.7
    });
  }
}

export default FeaturedResourceCardsWithImage;
